export const surveysConfigs = {
  key: 'surveys',
  title: 'Surveys',
};
